import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { getCtasBancariasContactoById } from "api/Contacto.service"
import CustomButton from "common/components/Button/Button"
import FormikDropdown from "common/components/FormikFields/FormikDropdown"
import FormikInputDate from "common/components/FormikFields/FormikInputDate"
import FormikInputNumber from "common/components/FormikFields/FormikInputNumber"
import FormikTextArea from "common/components/FormikFields/FormikTextArea"
import ContactoSelect from "features/Contabilidad/pages/Prestamos/components/NewPrestamoForm/components/ContactoSelect"
import { getDropdownAccounts } from "features/Contabilidad/pages/Prestamos/components/NewPrestamoForm/constants"
import { CreateEditEntidadModalProps } from "features/Contactos/components/CuentasBancarias"
import { ModalAccountContactCuentaBancaria } from "features/Contactos/components/CuentasBancarias/Components/ModalAccountContactCuentaBancaria/ModalAccountContactCuentaBancaria"
import { Button } from "primereact/button"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { setInititalAccountValues } from "./constants"

const DevolucionForm = ({
  onHide,
  handleChange,
  setFieldValue,
  values,
  handleSubmit,
  errors,
  touched,
  handleBlur,
  isEditView,
  data,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const [selectedAccount, setSelectedAccount] = useState()

  const [cuentasBancarias, setCuentasBancarias] = useState([])
  const [createOrEditModal, setCreateOrEditModal] =
    useState<CreateEditEntidadModalProps>({
      show: false,
      isEdit: undefined,
    })

  const onHideCreateOrEditModal = () =>
    setCreateOrEditModal({
      show: false,
      isEdit: undefined,
    })
  useEffect(() => {
    async function fetchCuentasBancarias() {
      if (values.empresaId) {
        const data = await getCtasBancariasContactoById(values.empresaId)
        // @ts-expect-error TS(2345): Argument of type 'CuentaBancariaContactoReadingDto...
        setCuentasBancarias(data ?? [])
      }
    }

    fetchCuentasBancarias()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.empresaId])

  useEffect(() => {
    if (data?.empresaId && cuentasBancarias?.length) {
      setInititalAccountValues(
        data,
        cuentasBancarias,
        setSelectedAccount,
        setFieldValue
      )
    }
  }, [
    cuentasBancarias,
    data,
    data?.cuentaBancariaId,
    data?.empresaId,
    setFieldValue,
  ])

  const handleSelectContacto = async (value: $TSMigrationFixMe) => {
    setFieldValue("empresaId", value.empresaContactoId)
    setFieldValue("empresaContactoId", value.id)
    const resp = await getCtasBancariasContactoById(value.empresaContactoId)
    // @ts-expect-error TS(2345): Argument of type 'CuentaBancariaContactoReadingDto...
    setCuentasBancarias(resp)
  }

  const handleBankAccount = ({ value }: $TSMigrationFixMe) => {
    const account = {
      cuentaIdExterno: value.id,
      iban: value.iban,
      bic: value.bic,
      entidadBancariaId: value.id,
    }
    setFieldValue("cuentaBancaria", account)
    setSelectedAccount(value)
  }

  const handleCreateCtaBancaria = async () => {
    const cuentasBancaraisArray = await getCtasBancariasContactoById(
      values.empresaId
    )
    // @ts-expect-error TS(2345): Argument of type 'CuentaBancariaContactoReadingDto...
    setCuentasBancarias(cuentasBancaraisArray)
  }

  const handleShowModalCtaBancaria = async () => {
    setCreateOrEditModal({
      show: true,
      isEdit: undefined,
    })
  }

  return (
    <div>
      <form>
        <div className='mb-3 p-fluid'>
          <div className='p-field'>
            <ContactoSelect
              title={t("devoluciones.modal.clientLabel")}
              className='w-100'
              panelClassName='!tw-z-[2302]'
              isComprador={false}
              getClienteProveedor={handleSelectContacto}
              errors={touched?.empresaId && errors?.empresaId}
              onBlur={handleBlur}
              values={values}
              razonSocial={data?.razonSocial}
            />
          </div>
          <div className='mb-3 select_container'>
            <label htmlFor='tipoDocumento'>
              {t("devoluciones.modal.accountLabel")}
            </label>
            <FormikDropdown
              options={getDropdownAccounts(cuentasBancarias)}
              value={selectedAccount}
              onChange={(value: $TSMigrationFixMe) => handleBankAccount(value)}
              placeholder={t("devoluciones.modal.placeholderAccount")}
              emptyFilterMessage={t("devoluciones.modal.emptyMsg")}
              emptyMessage={t("devoluciones.modal.emptyMsg")}
              fluid
              id='cuentaBancaria.cuentaIdExterno'
              name='cuentaBancaria.cuentaIdExterno'
              onBlur={handleBlur}
              disabled={!values.empresaId}
              panelClassName='!tw-z-[2302]'
            />
            {values.empresaId ? (
              <span
                onClick={() => values.empresaId && handleShowModalCtaBancaria()}
                className='text-gedesco link-cancel añadir-cuenta_container mt-3'
              >
                <FontAwesomeIcon icon={["fal", "plus"]} />{" "}
                {t("devoluciones.modal.addNewAccountLabel")}
              </span>
            ) : null}
          </div>
          <label htmlFor='descripcion'>
            {t("devoluciones.modal.descriptionLabel")}
          </label>
          <FormikTextArea
            id='descripcion'
            name='descripcion'
            placeholder={t("devoluciones.modal.placeholderDescrip")}
            onBlur={handleBlur}
            value={values.descripcion}
            onChange={handleChange}
            autoComplete='off'
          />
          <div className='mt-3 mb-3 input-group_container'>
            <div className='input_box'>
              <label htmlFor='importe'>
                {t("devoluciones.modal.importLabel")}
              </label>
              <FormikInputNumber
                id='importe'
                name='importe'
                onBlur={handleBlur}
                disabled={data?.remesaId}
                minFractionDigits={2}
              />
            </div>
            <div className='input_box'>
              <label htmlFor='fecha'>{t("devoluciones.modal.dateLabel")}</label>
              <FormikInputDate
                id='fecha'
                name='fecha'
                onChange={handleChange}
                onBlur={handleBlur}
                value={values?.fecha}
              />
            </div>
          </div>
        </div>
      </form>
      <div className='d-flex justify-content-end'>
        <div className='departaments-modal__actions'>
          <Button
            className='text d-flex justify-content-center'
            // @ts-expect-error TS(2769): No overload matches this call.
            type='text'
            onClick={onHide}
          >
            {t("devoluciones.modal.cancelButton")}
          </Button>
          <CustomButton
            onClick={handleSubmit}
            className={`tw-ml-2 ${
              isEditView
                ? "!tw-bg-primary tw-cursor-pointer"
                : "!tw-bg-secondary hover:!tw-bg-secondary-over !tw-border-none tw-cursor-pointer"
            }`}
          >
            {isEditView
              ? `${t("devoluciones.modal.saveButton")}`
              : `${t("devoluciones.modal.createButton")}`}
          </CustomButton>
        </div>
      </div>

      {values.empresaContactoId && (
        <ModalAccountContactCuentaBancaria
          id={values.empresaContactoId}
          createOrEditModal={createOrEditModal}
          onHide={onHideCreateOrEditModal}
          contactosCuentaBancariaByIdRefetch={handleCreateCtaBancaria}
        />
      )}
    </div>
  )
}

export default DevolucionForm
